var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "fill",
    d: "M15.836 3.10083C17.3912 3.10083 18.6536 4.36323 18.6536 5.91843H20.5328C22.088 5.91843 23.3504 7.18083 23.3504 8.73603V18.1272C23.3504 19.6824 22.088 20.9448 20.5328 20.9448H4.568C3.0128 20.9448 1.7504 19.6824 1.7504 18.1272V5.91843C1.7504 4.36323 3.0128 3.10083 4.568 3.10083H15.836ZM15.836 4.50963H4.568C3.8216 4.50963 3.2048 5.09043 3.1616 5.83683L3.1592 5.91843H17.2472C17.2472 5.17203 16.6664 4.55523 15.92 4.51203L15.836 4.50963Z",
    fill: "#ABAEB2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3504 9.67432V15.3095H17.2448C15.6896 15.3095 14.4272 14.0471 14.4272 12.4919C14.4272 10.9367 15.6896 9.67432 17.2448 9.67432H23.3504ZM17.2448 11.0831C16.4672 11.0831 15.836 11.7119 15.836 12.4919C15.836 13.2695 16.4648 13.9007 17.2448 13.9007H17.2472C18.0248 13.9007 18.656 13.2695 18.656 12.4919C18.6558 12.3068 18.6192 12.1234 18.5482 11.9524C18.4772 11.7814 18.3732 11.6261 18.2422 11.4952C18.1111 11.3644 17.9556 11.2607 17.7845 11.19C17.6133 11.1193 17.4299 11.083 17.2448 11.0831Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.1143eedee64055828f5f3eb8dfe57d35.svg";
export { ForwardRef as ReactComponent };